import { Backdrop } from "@mui/material";
import "./loading.css";

const Loading = (props) => {
  const logo = "https://public.siafevolution.com.br/icon-lite-white.svg";

  return (
    <Backdrop style={{ zIndex: 2000 }} open={props.loading}>
      <div className="d-flex flex-column align-items-center">
        <img src={logo} id="logosiaf" className="rotate-center w-25" alt="" />
      </div>
    </Backdrop>
  );
};

export default Loading;
